import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create()

const servicesAPI = {
  mostrarOrden(id) {
    var url = ConfigAPI.baseURL + 'purchase-orders/' + id + Session.getToken()
    return instance.get(url)
  },
  agregarOrden(data) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders' + Session.getToken()
    return instance.post(url, params)
  },
  editarOrden(data) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders/' + data.id + Session.getToken()
    return instance.post(url, params)
  },
  actualizarEstadoOrden(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders/' + id + '/status' + Session.getToken()
    return instance.post(url, params)
  },
  eliminarOrden(id) {
    var url = ConfigAPI.baseURL + 'purchase-orders/' + id + Session.getToken()
    return instance.delete(url)
  },
  filtrarOrdenes(data, page) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders/filter/query' + Session.getToken() + '&page=' + page
    return instance.post(url, params)
  },
  obtenerSugerencias(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders/' + id + '/suggestions' + Session.getToken()
    return instance.post(url, params)
  },
  obtenerSugerenciasPorProveedor(data) {
    var params = data
    var url = ConfigAPI.baseURL + 'purchase-orders/suggestions/query' + Session.getToken()
    return instance.post(url, params)
  },

  obtenerProveedores() {
    var url = ConfigAPI.baseURL + 'suppliers' + Session.getToken()
    return instance.get(url)
  },
  toggleHiddenSuggestion(detailId) {
    var url = ConfigAPI.baseURL + 'purchase-orders/details/' + detailId + '/toggle-hidden-suggestion' + Session.getToken()
    return instance.post(url)
  },
}

export default servicesAPI
